import styled from 'styled-components';
import {
  Accordion as SemanticAccordion,
} from 'semantic-ui-react';

const Accordion = styled(SemanticAccordion)`
  &&& {
    .title {
      padding: 0 !important;
    }

    .active {
      padding: 0 !important;
    }
  }
`;

export {
  Accordion,
};
